//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import treetag from "@/pccomponents/TreeTag";
import NoDataDisplay from "@/pccomponents/NoDataDisplay";
export default {
  name:'SelectUserInfo',
  components: {
    treetag,
    NoDataDisplay
  },
  props:{
    //sys_cselectpub表的selectwintype字段
    selectWinType:{
      type: String,
      default: ''
    },
    //人员选择框是否是多选
    isMultiple:{
      type: Boolean,
      default: true
    },
    //当前行项的index
    rowindex:{
      type: Number,
      default: -1
    },
    //回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    //当前选中的账号
    selectuserid:{
      type:String,
      default:null
    },
    //编辑项
    editItem:{
      type:String,
      default:''
    },
    //匹配的编辑项
    matchItem:{
      type:String,
      default:''
    },
    // 输入框是否可编辑
    isEdit: {
        type: Boolean,
        default: false
    },
    // 清空的图标
    clearIcon: {
        type: String,
        default: "el-icon-close"
    },
    // 是否隐藏按钮的内容
    hideSpan: {
        type: Boolean,
        default: true
    },
    // 输入框是否有值，有值才显示清除值的按钮
    hasVal: {
        type: String,
        default: ""
    },
    // 传入参数
    scon: {
        type: String,
        default: '1'
    },
    flowsysid:{
      type:String,
      default:'FLOW'
    },
    isDeptLead:{//是否展示部门领导
      type:String,
      default:''
    },
    //打开弹出框前执行
    beforeOpenSelect:{
      type:Function,
      require: false
    }
  },
  data() {
    return {
      //控制人员选择框显示与否
      dialogVisible: false,

      //定义树显示的格式
      defaultProps: {
        children: 'children',
        label: 'deptname'
      },
      //定义人员列表列
     userListHeardFormat: [
        {prop: 'username', label: this.$t('selectUser.username')},
        {prop: 'userid', label: this.$t('selectUser.account')},
        {prop: 'deptname', label: this.$t('selectUser.deptname')},
      ],

      //中间人员记录
      userList:[],

      //已选择的人员记录
      selectuserList:[],
      //查询记录
      queryinfo:{
        vdeptid:"",
        vusername:""
      },
      //左侧树列表
      deptList: [
      ],
      currPage:1,
      rowsPerPage:10,
      totalPage:0,
      urlUserList :"userController/userlist",//查询人员URL
    }
  },
  methods: {
    /**
     * 公用页面切换方法
     */
    PageChange(oPage) {
      this.currPage = oPage.page_index;
      this.rowsPerPage = oPage.page_limit;
      // this.initData();
      let params = {
        deptid : this.queryinfo.vdeptid,
        flowsysid:this.flowsysid
      }
      this.clickDeptTree(params) ;
    },

    //初始化人员信息
    initSelectUser(){
      //默认人员不为空或者不为''，则进行初始化
      if(this.selectuserid != null && this.selectuserid !=''){
        let params ={
          selectUserid : this.selectuserid,
          flowsysid:this.flowsysid
        };
        let url = "userController/initSelectUser";
         //请求后端数据
          this.axios.post(url, params).then(({ data }) => {
            if(data.code=='1'){
              this.selectuserList = data.data.userInfoList;
            }else{
              console.log('2019年11月22日17:31:51 SelectUserInfo.vue[人员选择框-初始化人员信息，后台返回失败]——[data.code] :',data.code);
            }
         }).catch((error)=>{
            console.log('2019年11月22日17:25:38 SelectUserInfo.vue[人员选择框-初始化人员信息，访问后台失败]——[error] :',error);
         })
      }
    },
    //弹出人员选择框
    openSelectPerson(){
      let flag = true;
      try {
          flag = this.beforeOpenSelect(this.rowindex);
      } catch (error) {
          flag = true;
      }
      if(!flag){
         return false;
      }

      //初始化选中人员的列表
      this.initSelectUser();

      this.dialogVisible=true
    },
    /**
     * 点击确定按钮，回写人员信息到表单
     */
    confirmUserInfo() {
      //回写显示的名称格式：“张三”
      let username = "";
      //回写显示名称格式：“张三/综合部”
      let usernamedept = "";
      //回写隐藏的账号格式：“zhangsan”
      let userid = "";
      //回写隐藏的账号格式:“zhangsan/888888”
      let userdeptid = "";

      if(this.selectuserList&&this.selectuserList.length!==0){

        for(let userInfo of this.selectuserList){
            if(username === ''){
                username = userInfo['username'];
            }else{
                username = username+";"+userInfo['username'];

            }

            if(usernamedept === ''){
                usernamedept = userInfo['username']+"/"+userInfo['deptname'];
            }else{
                usernamedept = usernamedept +";"+userInfo['username']+"/"+userInfo['deptname'];

            }

            if(userid === ''){
                userid = userInfo["userid"];
            }else{
                userid = userid+";"+userInfo["userid"];
            }

            if(userdeptid === ''){
                userdeptid = userInfo["userid"]+"/"+userInfo['deptid']
            }else{
              userdeptid = userdeptid+";"+userInfo["userid"]+"/"+userInfo['deptid'];
            }
        }

        this.$emit('update:username', username);
        this.$emit('update:usernamedept',usernamedept);
        this.$emit('update:userid',userid);
        this.$emit('update:userdeptid',userdeptid);
        //回调函数不为空的话，则调用父类的回调函数进行业务处理 rowindex 表示的是行项的第几行
        if(this.callbackFun != null){
            let params = {
                rowindex : this.rowindex,
                returnData : this.selectuserList
            }
            this.callbackFun(params);
        }
        this.dialogVisible = false;
      }else{
        //提示请选择人员信息
        let tipMsg = this.$t('common.selnulluserinfotip');
        this.tipWarn(tipMsg);
      }
    },
    /**
     * 清空人员信息
     */
    clearUserInfo(){
      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        let returnData=[{
          username:'',
          usernamedept:'',
          userid:'',
          userdeptid:'',
        }];
        const keys=Object.keys(this.selectuserList)
        keys.forEach(key=>{this.selectuserList[key] = ''})
        let params = {
            rowindex : this.rowindex,
            returnData : returnData
        }
        this.callbackFun(params);
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        this.$emit('update:username', "");
        this.$emit('update:usernamedept',"");
        this.$emit('update:userid',"");
        this.$emit('update:userdeptid',"");
      }
    },
    //删除人员
    delSelectUser(row, column, event) {
      for (let i = 0; i < this.selectuserList.length; i++) {
        //此处需要进行修改，将userid该为可动态变更
        if (this.selectuserList[i] === row) {
          this.selectuserList.splice(i, 1)
        }
      }
    },
    /**
     * 点击取消按钮
     */
    cancelUserInfo() {
      this.dialogVisible = false,
      //将选中的人员清空
      this.selectuserList = [];
      //清空中间人员列表
      this.userList = [];
      //记录的部门信息清空
      this.queryinfo.vdeptid = "";
      //清空选择信息
      this.queryinfo.vusername = "";
    },
    /**
     * 点击树形节点回调函数
     */
    deptClick(treeNode) {
      this.queryinfo.vdeptid = treeNode.id;
      if(this.queryinfo.vdeptid != '0' && this.queryinfo.vdeptid != ''){
        let params = {
          queryinfo:{
            vdeptid :this.queryinfo.vdeptid,
            name_id :this.queryinfo.vusername,
            isdeptlead:this.isDeptLead
          },
          pageinfo:{
              currPage: this.currPage,
              rowsPerPage: this.rowsPerPage
          },
          flowsysid:this.flowsysid
        }

        //请求后端数据
        this.axios.post(this.urlUserList, params).then(({ data }) => {
            if(data.code === '1'){
              this.userList = data.data.record;
              this.totalPage = data.data.pageinfo.count;
            }else{
              console.log('2019年11月13日11:20:37 SelectUserInfo.vue[描述]——[data.msg] :',data.msg);
            }
        });
      }
    },
    /**
     * 搜索人员信息
     */
    searchUser(){
      let params = {
        deptid : this.queryinfo.vdeptid,
        flowsysid:this.flowsysid
      }
      this.clickDeptTree(params) ;
    },
    /**
     * 点击树动态更新中间人员记录
     */
    clickDeptTree(data) {
      this.queryinfo.vdeptid = data.deptid;
      let params = {
        queryinfo:{
          vdeptid :this.queryinfo.vdeptid,
          name_id :this.queryinfo.vusername,
          isdeptlead:this.isDeptLead
        },
        pageinfo:{
            currPage: this.currPage,
            rowsPerPage: this.rowsPerPage
        },
        flowsysid:this.flowsysid
      }

      //请求后端数据
      this.axios.post(this.urlUserList, params).then(({ data }) => {
          if(data.code === '1'){
            this.userList = data.data.record;
            this.totalPage = data.data.pageinfo.count;
          }else{
            console.log('2019年11月13日11:20:02 SelectUserInfo.vue[描述]——[data.msg] :',data.msg);
          }
      });
    },
     /**
     *双击选中人员信息
     */
    selectUser(row, column, event) {
      const obj = {};
      //复制选中行的全部信息到最右侧
      for(let key in row){
        obj[key] = row[key];
      }
      //允许用户多选
      if(this.isMultiple){
        //判断当前点击账号和部门是否已经存在选中的列表中，不存在的话则进行添加
        let flag = false;
        let currentAccount = row["userid"];
        let currentDeptId = row["deptid"];
        for(let i = 0 ; i < this.selectuserList.length;i++){
           let selectRow = this.selectuserList[i];
           let selectAccount = selectRow["userid"];
           let selectDeptId = selectRow["deptid"];
           if(currentAccount === selectAccount && currentDeptId == selectDeptId){
              flag = true;
              break;
           }
        }
        //未选中当前用户，则进行添加
        if(!flag){
          this.selectuserList.push(obj);
        }

      }else{
        //单选的话，则直接替换数组
        this.selectuserList.length=0
        this.selectuserList.push(obj)
      }
    },
    openModel() {
        this.setDialogPos();
    }
	
	},
  //计算属性
  computed: {
    readonly: function () {
      if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
        return false;
      }else{
        //若编辑域有该值则显示
        return true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectUserInfo.vue